import { render, staticRenderFns } from "./list-share-modal.vue?vue&type=template&id=0b484502&scoped=true&"
import script from "./list-share-modal.vue?vue&type=script&lang=ts&"
export * from "./list-share-modal.vue?vue&type=script&lang=ts&"
import style0 from "./list-share-modal.vue?vue&type=style&index=0&id=0b484502&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b484502",
  null
  
)

export default component.exports